module.exports = __webpack_public_path__ + "static/media/1_en.42dbc08a.png";